(function () {
  'use strict';

  var desktopBreakpoint = 1100;
  var hoverDelay = 140;

  function createHeaderController(root) {
    if (!root || root.__hmmController) return root && root.__hmmController;

    var triggers = Array.prototype.slice.call(root.querySelectorAll('[data-hmm-panel-trigger]'));
    var panels = Array.prototype.slice.call(root.querySelectorAll('[data-hmm-panel]'));
    var backdrop = root.querySelector('[data-hmm-backdrop]');
    var drawer = root.querySelector('#hmm-drawer');
    var drawerOpenButton = root.querySelector('[data-hmm-drawer-open]');
    var drawerCloseButton = root.querySelector('[data-hmm-drawer-close]');
    var drawerSectionToggles = Array.prototype.slice.call(root.querySelectorAll('[data-hmm-drawer-toggle]'));
    var cartOpenButtons = Array.prototype.slice.call(root.querySelectorAll('[data-hmm-cart-open]'));
    var nativeCartTrigger = root.querySelector('.hmm-cart-proxy [data-testid="cart-drawer-trigger"]');
    var header = root.querySelector('.hmm-header');
    var cleanupFns = [];
    var openPanel = null;
    var openTrigger = null;
    var hoverTimer = null;

    function isDesktop() {
      return window.innerWidth > desktopBreakpoint;
    }

    function canHover() {
      return isDesktop() && window.matchMedia('(hover: hover)').matches;
    }

    function panelForTrigger(trigger) {
      return document.getElementById(trigger.getAttribute('aria-controls'));
    }

    function setBackdrop(visible) {
      if (!backdrop) return;
      if (visible) {
        backdrop.hidden = false;
        backdrop.offsetHeight;
        backdrop.classList.add('is-visible');
      } else {
        backdrop.classList.remove('is-visible');
        window.setTimeout(function () {
          if (!openPanel && (!drawer || !drawer.classList.contains('is-open'))) {
            backdrop.hidden = true;
          }
        }, 200);
      }
    }

    function positionCompactPanel(panel, trigger) {
      if (!panel || !panel.classList.contains('hmm-panel--compact')) return;

      var inner = root.querySelector('.hmm-inner');
      if (!inner) return;

      var triggerAnchor = trigger.closest('.hmm-nav-item') || trigger;
      var triggerRect = triggerAnchor.getBoundingClientRect();
      var panelWidth = panel.getBoundingClientRect().width || 340;
      var maxWidth = Math.min(panelWidth, window.innerWidth - 24);
      var left = triggerRect.left;
      var minLeft = 12;
      var maxLeft = window.innerWidth - maxWidth - 12;

      if (left < minLeft) left = minLeft;
      if (left > maxLeft) left = maxLeft;

      panel.style.left = left + 'px';
      panel.style.right = 'auto';
    }

    function openDesktopPanel(panel, trigger) {
      if (!isDesktop() || !panel) return;

      if (openPanel && openPanel !== panel) {
        closeDesktopPanel(false);
      }

      panel.hidden = false;
      positionCompactPanel(panel, trigger);
      panel.offsetHeight;
      panel.classList.add('is-open');
      trigger.setAttribute('aria-expanded', 'true');
      openPanel = panel;
      openTrigger = trigger;
    }

    function closeDesktopPanel(restoreFocus) {
      if (!openPanel) return;

      var panel = openPanel;
      var trigger = openTrigger;
      panel.classList.remove('is-open');
      panel.setAttribute('hidden', '');
      panel.style.left = '';
      panel.style.right = '';

      if (trigger) {
        trigger.setAttribute('aria-expanded', 'false');
        if (restoreFocus) trigger.focus();
      }

      openPanel = null;
      openTrigger = null;
    }

    function scheduleClose() {
      window.clearTimeout(hoverTimer);
      hoverTimer = window.setTimeout(function () {
        closeDesktopPanel(false);
      }, hoverDelay);
    }

    function cancelClose() {
      window.clearTimeout(hoverTimer);
    }

    function lockBody(lock) {
      document.body.classList.toggle('hmm-locked', lock);
    }

    function openDrawer() {
      if (!drawer) return;
      drawer.hidden = false;
      drawer.offsetHeight;
      drawer.classList.add('is-open');
      if (drawerOpenButton) drawerOpenButton.setAttribute('aria-expanded', 'true');
      setBackdrop(true);
      lockBody(true);
      window.setTimeout(function () {
        if (drawerCloseButton) drawerCloseButton.focus();
      }, 30);
    }

    function closeDrawer(restoreFocus) {
      if (!drawer) return;
      drawer.classList.remove('is-open');
      if (drawerOpenButton) {
        drawerOpenButton.setAttribute('aria-expanded', 'false');
        if (restoreFocus) drawerOpenButton.focus();
      }
      lockBody(false);
      setBackdrop(false);
      window.setTimeout(function () {
        if (!drawer.classList.contains('is-open')) drawer.hidden = true;
      }, 280);
    }

    function bind(target, eventName, handler, options) {
      target.addEventListener(eventName, handler, options);
      cleanupFns.push(function () {
        target.removeEventListener(eventName, handler, options);
      });
    }

    triggers.forEach(function (trigger) {
      var panel = panelForTrigger(trigger);
      if (!panel) return;

      bind(trigger, 'click', function (event) {
        event.preventDefault();
        if (!isDesktop()) return;
        if (openPanel === panel) {
          closeDesktopPanel(false);
        } else {
          openDesktopPanel(panel, trigger);
        }
      });

      bind(trigger, 'mouseenter', function () {
        if (!canHover()) return;
        cancelClose();
        openDesktopPanel(panel, trigger);
      });

      var navItem = trigger.closest('.hmm-nav-item');
      if (navItem && navItem !== trigger) {
        bind(navItem, 'mouseenter', function () {
          if (!canHover()) return;
          cancelClose();
          openDesktopPanel(panel, trigger);
        });
      }

      bind(panel, 'mouseenter', function () {
        if (!canHover()) return;
        cancelClose();
      });

      bind(panel, 'mouseleave', function () {
        if (!canHover()) return;
        scheduleClose();
      });
    });

    if (header) {
      bind(header, 'mouseenter', function () {
        if (!canHover()) return;
        cancelClose();
      });

      bind(header, 'mouseleave', function () {
        if (!canHover()) return;
        scheduleClose();
      });
    }

    if (drawerOpenButton) {
      bind(drawerOpenButton, 'click', function () {
        if (drawer && drawer.classList.contains('is-open')) closeDrawer(false);
        else openDrawer();
      });
    }

    if (drawerCloseButton) {
      bind(drawerCloseButton, 'click', function () {
        closeDrawer(true);
      });
    }

    cartOpenButtons.forEach(function (button) {
      bind(button, 'click', function () {
        if (nativeCartTrigger) {
          nativeCartTrigger.click();
        }
      });
    });

    drawerSectionToggles.forEach(function (toggle) {
      bind(toggle, 'click', function () {
        var section = toggle.closest('[data-hmm-drawer-section]');
        var body = section ? section.querySelector('.hmm-dsec-body') : null;
        if (!body) return;

        var expanded = toggle.getAttribute('aria-expanded') === 'true';
        toggle.setAttribute('aria-expanded', expanded ? 'false' : 'true');
        body.hidden = expanded;
      });
    });

    bind(document, 'click', function (event) {
      if (openPanel && !root.contains(event.target)) {
        closeDesktopPanel(false);
      }
    });

    bind(document, 'keydown', function (event) {
      if (event.key !== 'Escape') return;

      if (drawer && drawer.classList.contains('is-open')) {
        closeDrawer(true);
        return;
      }

      if (openPanel) {
        closeDesktopPanel(true);
      }
    });

    if (backdrop) {
      bind(backdrop, 'click', function () {
        if (drawer && drawer.classList.contains('is-open')) {
          closeDrawer(false);
        }
      });
    }

    bind(root, 'focusout', function (event) {
      if (!root.contains(event.relatedTarget) && openPanel) {
        closeDesktopPanel(false);
      }
    });

    bind(window, 'resize', function () {
      if (openPanel && openTrigger) {
        if (!isDesktop()) {
          closeDesktopPanel(false);
        } else {
          positionCompactPanel(openPanel, openTrigger);
        }
      }

      if (drawer && drawer.classList.contains('is-open') && isDesktop()) {
        closeDrawer(false);
      }
    });

    root.__hmmController = {
      destroy: function () {
        window.clearTimeout(hoverTimer);
        closeDesktopPanel(false);
        closeDrawer(false);
        cleanupFns.forEach(function (cleanup) {
          cleanup();
        });
        cleanupFns = [];
        delete root.__hmmController;
      }
    };

    return root.__hmmController;
  }

  function initAllMegaMenus(scope) {
    var context = scope && scope.querySelectorAll ? scope : document;
    Array.prototype.forEach.call(context.querySelectorAll('[data-hmm]'), function (root) {
      createHeaderController(root);
    });
  }

  function destroyMegaMenus(scope) {
    var context = scope && scope.querySelectorAll ? scope : document;
    Array.prototype.forEach.call(context.querySelectorAll('[data-hmm]'), function (root) {
      if (root.__hmmController) {
        root.__hmmController.destroy();
      }
    });
  }

  initAllMegaMenus(document);

  document.addEventListener('shopify:section:load', function (event) {
    initAllMegaMenus(event.target);
  });

  document.addEventListener('shopify:section:unload', function (event) {
    destroyMegaMenus(event.target);
  });
})();
